import React from 'react';

import {
    Box,
    H1,
} from '@saladbob/sassafras'

import styles from './bracket.module.css';


import Bracket4 from './Bracket4';
import Bracket5 from './Bracket5';
import Bracket6 from './Bracket6';
import Bracket7 from './Bracket7';
import Bracket8 from './Bracket8';
import Bracket9 from './Bracket9';
import Bracket10 from './Bracket10';
import Bracket11 from './Bracket11';
import Bracket12 from './Bracket12';
import Bracket13 from './Bracket13';
import Bracket14 from './Bracket14';
import Bracket15 from './Bracket15';
import Bracket16 from './Bracket16';
import Bracket17 from './Bracket17';
import Bracket18 from './Bracket18';

import { CourtDepth, Game, Team } from '../../types'

type Props = {
    court: CourtDepth,
};

type BracketProps = {
    games: Game[],
    tbGames: Game[],
    teams: Team[]
    standings?: any[],
}

const brackets = {
    4: (props: BracketProps) => (<Bracket4 {...props} />),
    5: (props: BracketProps) => (<Bracket5 {...props} />),
    6: (props: BracketProps) => (<Bracket6 {...props} />),
    7: (props: BracketProps) => (<Bracket7 {...props} />),
    8: (props: BracketProps) => (<Bracket8 {...props} />),
    9: (props: BracketProps) => (<Bracket9 {...props} />),
    10: (props: BracketProps) => (<Bracket10 {...props} />),
    11: (props: BracketProps) => (<Bracket11 {...props} />),
    12: (props: BracketProps) => (<Bracket12 {...props} />),
    13: (props: BracketProps) => (<Bracket13 {...props} />),
    14: (props: BracketProps) => (<Bracket14 {...props} />),
    15: (props: BracketProps) => (<Bracket15 {...props} />),
    16: (props: BracketProps) => (<Bracket16 {...props} />),
    17: (props: BracketProps) => (<Bracket17 {...props} />),
    18: (props: BracketProps) => (<Bracket18 {...props} />),
};

const Bracket: React.FC<Props> = ({ court }) => {
    if (!court.teams || court.teams.length < 4) {
        return (
            <Box bgColor="black" verticalAlign="center" align="center">
                <H1 color="white">BRACKET&apos;S UNDER CONSTRUCTION</H1>
            </Box>
        )
    }
    return (<>
        <div className={styles.bracket}>
            <div className={styles.bracketViewport}>
                <div className={styles.bracketScale}>
                    {court.teams && court.teams.length > 3 && court.teams.length < 19 && brackets[court.teams.length]({
                        games: court.games,
                        tbGames: court.tbGames,
                        standings: court.standings,
                        teams: court.teams,
                    })}
                </div>
            </div>
        </div>
    </>);
}

export default Bracket;
